export const fetchAddressByCep = async (cep) => {
  const digits = String(cep || '').replace(/\D/g, '');
  if (digits.length !== 8) {
    throw new Error('CEP inválido');
  }

  const res = await fetch(`https://viacep.com.br/ws/${digits}/json/`);
  if (!res.ok) {
    throw new Error('Não foi possível buscar o CEP');
  }

  const data = await res.json();
  if (data.erro) {
    throw new Error('CEP não encontrado');
  }

  return {
    street: data.logradouro || '',
    neighborhood: data.bairro || '',
    city: data.localidade || '',
    state: data.uf || '',
    postalCode: digits,
  };
};
